// extracted by mini-css-extract-plugin
module.exports = {"content":"with-drawer_content__c6X_R"};